import React, { Component } from "react";
import Header from "../layout/Header";
import Banner from "../Common/Banner";

export default class AboutPrincipal extends Component {
  render() {
    return (
      <div className="body_wrapper">
        <Header />
        <Banner title="Principal Desk" image="banners/About.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl paddingtop-2">
            <div className="row">
              <div className="col-lg-5">
                <div className="ttm-featured-wrapper">
                  <div className="featured-thumbnail text-center">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        `/assets/images/aboutprincipal/principal.jpg`
                      }
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-7 justify" style={{ margin: "auto" }}>
                <div className="ttm-team-member-content shadow-box res-991-mt-30">
                  <div className="ttm-team-member-content shadow-box res-991-mt-30">
                    <div className="ttm-team-member-single-list">
                      <h2 className="ttm-team-member-single-title">
                        Dr. PREM KUMAR.B. N
                      </h2>
                      <span
                        className="ttm-team-member-single-position"
                        style={{ fontWeight: "500" }}
                      >
                        MPT(Neuro), PhD.
                        <br />
                        Designation : Principal
                        <br />
                        Ph.No : +91 9845047646
                        <br />
                        Email : kimsphysiotherapy@gmail.com
                      </span>
                      <hr />
                      <p>Dear Students,</p>
                      <p>
                        A warm welcome to Kempegowda Institute of PhysioTherapy,
                        Bangalore. Physiotherapy is growing in giant strides,
                        and we are experiencing advancements in all the spheres
                        every day. Since the inception of our Institution in
                        1997, we believe that a Best Physiotherapist must
                        possess utmost knowledge in every medical speciality and
                        have excellent values and ethical attributes. This is
                        derived from the knowledge of technological growths
                        perceived by HUMANE TOUCH.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 paddingtop-2 justify">
                <p>
                  Established in the year 1906, our institution is affiliated
                  with the esteemed Rajiv Gandhi University of Health Sciences,
                  Government of Karnataka. Our college offers Bachelor of
                  Physiotherapy (BPT) since 1997, Master of Physiotherapy (MPT)
                  since 2004, and Doctor of Philosophy (Ph.D.) from 2022.
                </p>

                <p>
                  We believe that “Growth is Development” and strive to reach
                  every individual in need of rehabilitation and care, promoting
                  overall wellbeing. Our mission is to provide a world-class
                  educational experience through our multi-disciplinary campus,
                  empowering students to excel in their chosen specialities.
                </p>

                <p>
                  As we strongly uphold, “Physiotherapy is not just about
                  strengthening muscles, it’s about empowering people,” and
                  “Physiotherapy is not a punishment for being injured or
                  disabled, it’s a celebration of what your body can still do.”
                  These values guide our teaching and clinical practices.
                </p>

                <p>
                  We focus on helping students understand the patient’s
                  perspective, creating a strong connection between healthcare
                  and society. Our students are trained to treat individuals
                  efficiently and compassionately, irrespective of race, gender,
                  ethnicity, or social background, contributing to a healthier
                  community and a stronger nation.
                </p>

                <p>
                  Our institution is supported by highly qualified and
                  experienced faculty members with Doctorates, Postgraduate
                  qualifications, and extensive clinical and teaching
                  experience. We emphasize comprehensive training for
                  undergraduate (BPT), postgraduate (MPT), and doctoral (Ph.D.)
                  students, shaping them as future leaders in physiotherapy.
                </p>

                <p>
                  We provide high-quality education along with regular hands-on
                  clinical training, enabling students to become competent
                  professionals. Our excellent infrastructure and association
                  with KIMS & RI Hospital (established in 1980) ensure strong
                  clinical exposure and practical learning opportunities.
                </p>

                <p>
                  Students are encouraged to participate in academic,
                  co-curricular, and extracurricular activities at
                  intra-college, inter-state, and national levels, ensuring
                  their all-round development.
                </p>

                <p>
                  In the rapidly evolving healthcare environment, along with
                  advancements in information and communication technologies, we
                  focus on higher levels of learning, critical thinking, and
                  application of knowledge to prepare globally competent
                  physiotherapists. We emphasize developing the right attitude
                  and approach towards patient care.
                </p>

                <p>
                  With the continuous inspiration of our Chairman, Management,
                  faculty, and staff, Kempegowda Institute of Physiotherapy is
                  committed to achieving academic excellence and building a
                  bright future for our students.
                </p>

                <p>
                  We are grateful to our Management, Faculty, and Alumni for
                  their constant support. We firmly believe that “Working
                  together in harmony is walking towards glory.”
                </p>

                <p>I wish all students a rewarding and successful future.</p>

                <p>With Best Regards</p>

                <p>
                  <b style={{ fontWeight: "bold" }}>Dr. Prem Kumar B N</b>
                  <br />
                  Principal
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
